import "./Checkout2.module.css";
import Header from "@/reusable_sections/Header";
import Checkout from "./sections/Checkout";
import Footer from "@/reusable_sections/Footer";
export default function Checkout2Page() {
  return <div>
      <Header />
      <Checkout />
      <Footer />
    </div>;
}